import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { SESSION_STORAGE_KEYS } from '~/utils/sessionStorage';

interface State {
  isVisible: boolean;
  setClose: () => void;
}

const useMarketFloatingStore = create(
  persist<State>(
    (set) => ({
      isVisible: true,
      setClose: () => {
        set({ isVisible: false });
      },
    }),
    {
      name: SESSION_STORAGE_KEYS.MARKET_FLOATING,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export default useMarketFloatingStore;
